module.exports = __webpack_public_path__ + "home/img/logo.36f34a9f.svg";